var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M210.996 154.998C95.203 154.998.001 234.625.001 332.504c0 39.125 15.176 78.888 43.007 109.707L3.707 487.122a14.971 14.971 0 0 0-2.358 16.069 14.987 14.987 0 0 0 13.652 8.804h210.995c85.495 0 195.995-73.62 195.995-179.491 0-97.879-95.202-177.506-210.995-177.506zm-90.998 205c-16.538 0-29.999-13.462-29.999-29.999 0-16.538 13.462-29.999 29.999-29.999s29.999 13.462 29.999 29.999c.001 16.537-13.461 29.999-29.999 29.999zm90.998 0c-16.538 0-29.999-13.462-29.999-29.999 0-16.538 13.462-29.999 29.999-29.999s29.999 13.462 29.999 29.999-13.461 29.999-29.999 29.999zm90.998 0c-16.538 0-29.999-13.462-29.999-29.999 0-16.538 13.462-29.999 29.999-29.999s29.999 13.462 29.999 29.999-13.461 29.999-29.999 29.999z",
    fill: "#000000",
    opacity: 0.6313725490196078,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m508.371 305.228-35.316-41.205c25.209-28.446 38.935-63.134 38.935-99.021C511.989 74.023 424.511.006 316.994.006c-97.225 0-179.826 60.589-194.411 139.45 27.128-9.218 57.551-14.458 88.414-14.458 131.353 0 239.271 91.745 240.848 205h45.145c12.813.001 19.694-15.087 11.381-24.77z",
    fill: "#000000",
    opacity: 0.6313725490196078,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestIcon);
export default __webpack_public_path__ + "static/media/test-icon.e30c8bf8afca84e8d3ff5cf8bde8413d.svg";
export { ForwardRef as ReactComponent };